/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mcp_Server_Development_Work_0_BadgeInputs */

const en_svc_mcp_server_development_work_0_badge = /** @type {(inputs: Svc_Mcp_Server_Development_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tool-using AI tutor`)
};

const ar_svc_mcp_server_development_work_0_badge = /** @type {(inputs: Svc_Mcp_Server_Development_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`معلم ذكاء يستخدم الأدوات`)
};

const bn_svc_mcp_server_development_work_0_badge = /** @type {(inputs: Svc_Mcp_Server_Development_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`টুল-ব্যবহারকারী এআই শিক্ষক`)
};

const de_svc_mcp_server_development_work_0_badge = /** @type {(inputs: Svc_Mcp_Server_Development_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tool-nutzender KI-Tutor`)
};

const es_svc_mcp_server_development_work_0_badge = /** @type {(inputs: Svc_Mcp_Server_Development_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutor de IA que usa herramientas`)
};

const fr_svc_mcp_server_development_work_0_badge = /** @type {(inputs: Svc_Mcp_Server_Development_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuteur IA qui utilise des outils`)
};

const pt_svc_mcp_server_development_work_0_badge = /** @type {(inputs: Svc_Mcp_Server_Development_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutor de IA que usa ferramentas`)
};

const zh_svc_mcp_server_development_work_0_badge = /** @type {(inputs: Svc_Mcp_Server_Development_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会用工具的 AI 家教`)
};

const tr_svc_mcp_server_development_work_0_badge = /** @type {(inputs: Svc_Mcp_Server_Development_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Araç kullanan YZ eğitmen`)
};

const ru_svc_mcp_server_development_work_0_badge = /** @type {(inputs: Svc_Mcp_Server_Development_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ИИ-тьютор, использующий инструменты`)
};

const pl_svc_mcp_server_development_work_0_badge = /** @type {(inputs: Svc_Mcp_Server_Development_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutor AI używający narzędzi`)
};

/**
* | output |
* | --- |
* | "Tool-using AI tutor" |
*
* @param {Svc_Mcp_Server_Development_Work_0_BadgeInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mcp_server_development_work_0_badge = /** @type {((inputs?: Svc_Mcp_Server_Development_Work_0_BadgeInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mcp_Server_Development_Work_0_BadgeInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mcp_server_development_work_0_badge(inputs)
	if (locale === "bn") return bn_svc_mcp_server_development_work_0_badge(inputs)
	if (locale === "de") return de_svc_mcp_server_development_work_0_badge(inputs)
	if (locale === "es") return es_svc_mcp_server_development_work_0_badge(inputs)
	if (locale === "fr") return fr_svc_mcp_server_development_work_0_badge(inputs)
	if (locale === "pt") return pt_svc_mcp_server_development_work_0_badge(inputs)
	if (locale === "zh") return zh_svc_mcp_server_development_work_0_badge(inputs)
	if (locale === "tr") return tr_svc_mcp_server_development_work_0_badge(inputs)
	if (locale === "ru") return ru_svc_mcp_server_development_work_0_badge(inputs)
	if (locale === "pl") return pl_svc_mcp_server_development_work_0_badge(inputs)
	return en_svc_mcp_server_development_work_0_badge(inputs)
});
export { svc_mcp_server_development_work_0_badge as "svc_mcp-server-development_work_0_badge" }